import { render, staticRenderFns } from "./battalion-poster.vue?vue&type=template&id=77f08118&scoped=true"
import script from "./battalion-poster.vue?vue&type=script&lang=js"
export * from "./battalion-poster.vue?vue&type=script&lang=js"
import style0 from "./battalion-poster.vue?vue&type=style&index=0&id=77f08118&prod&lang=css"
import style1 from "./battalion-poster.vue?vue&type=style&index=1&id=77f08118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f08118",
  null
  
)

export default component.exports